export default __webpack_public_path__ + "static/media/phoneblack.79dd8b5f.svg";